import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VDialog,{attrs:{"persistent":"","width":"300"},model:{value:(_vm.retornar),callback:function ($$v) {_vm.retornar=$$v},expression:"retornar"}},[_c(VCard,{attrs:{"color":"blue darken-4"}},[_c(VCardText,[_c('span',{staticStyle:{"color":"white"}},[_vm._v(" Por favor, espere...")]),_c(VProgressLinear,{staticClass:"mb-0",attrs:{"indeterminate":"","color":"white"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }